<script lang="ts" generics="T extends string">import { page } from "$app/stores";
import { normaliseBase } from "./utils/normaliseBase.js";
import { base as maybe_relative_base } from "$app/paths";
import { parseRoute, serializeRoute } from "./utils/route.js";
const absoluteBase = normaliseBase(maybe_relative_base, new URL($page.url)) || "/";
export let availableLanguageTags;
export let strategy;
export let currentLang;
const getAlternateLinks = (canonicalPath2, strategy2) => {
  const links = [];
  for (const lang of availableLanguageTags) {
    const localisedPath2 = strategy2.getLocalisedPath(canonicalPath2, lang);
    const fullPath = serializeRoute(localisedPath2, absoluteBase, void 0);
    const link = new URL(fullPath, new URL($page.url)).href;
    links.push(link);
  }
  return links;
};
$: localisedPath = parseRoute($page.url.pathname, absoluteBase)[0];
$: canonicalPath = strategy.getCanonicalPath(localisedPath, currentLang);
$: alternateLinks = getAlternateLinks(canonicalPath, strategy);
</script>

<!-- If there is more than one language, add alternate links -->
{#if availableLanguageTags.length >= 1}
	{#each alternateLinks as href, i}
		<link rel="alternate" hreflang={availableLanguageTags[i]} {href} />
	{/each}
{/if}
